import Auth from '@/services/auth'
import {
  API_BASE,
  apiErrorHandler,
  ApiFilter,
  isDefinedAndNotNull,
  isNotEmpty,
} from '@/services/api'

export const wiseFormEndpoint = `${API_BASE}wise/`

export const wiseRequestOptions = {
  headers: {
    'Content-Type': 'application/json',
    ...Auth.getHeaders(),
  },
}
